module.exports = "//cdn.mxpnl.com/static/asset-cache/e058b52a89985d58fa6918ef5dba1c5c/iron/common/widgets/user-icon/mp-avatar.svg";